module.exports = __webpack_public_path__ + "img/work3.26ae145a.svg";